module.exports = __webpack_public_path__ + "static/img/document-default.db53ea6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v3/img/document-default.png
// module id = xKGz
// module chunks = 10